var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.activeMerchant
    ? _c(
        "div",
        { staticClass: "ui dropdown item", on: { click: _vm.fetchMerchants } },
        [
          _c("span", { staticClass: "active-merchant-name" }, [
            _vm._v(_vm._s(_vm.activeMerchant.name))
          ]),
          _vm._v(" "),
          _vm.merchants.length > 1
            ? _c("i", { staticClass: "dropdown icon" })
            : _vm._e(),
          _vm._v(" "),
          _vm.merchants.length > 1
            ? _c(
                "div",
                { staticClass: "menu" },
                _vm._l(_vm.merchants, function(merchant) {
                  return _c(
                    "a",
                    {
                      key: merchant.id,
                      staticClass: "item",
                      class: { active: merchant.id == _vm.activeMerchant.id },
                      on: {
                        click: function($event) {
                          return _vm.switchMerchant(merchant.id)
                        }
                      }
                    },
                    [_vm._v("\n\t\t\t\t" + _vm._s(merchant.name) + "\n\t\t\t")]
                  )
                }),
                0
              )
            : _vm._e()
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-f6419368", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f6419368","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/layout/MerchantMenu.vue
// module id = 1gLT
// module chunks = 1